export default __webpack_public_path__ + "static/media/users.196c8def.svg";